import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

function Form() {

    const URLstring         = "https://scriptadmin.cjdsa.co.za/assets/";
    const ACCESSCODE        = "75re85345";

    const [title, setTitle]                                  = useState('');
    const [number, setNumber]                                = useState('');
    const [images, setImages]                                = useState([]);
    const [singleImage, setSingleImage]                      = useState(null);
    const [idImage, setIDImage]                              = useState('');
    const [currentScripts, setCurrentScripts]                = useState([]);

    const [isModalOpen, setIsModalOpen]                      = useState(false);

    const [uploadProgress, setUploadProgress]                = useState({});

    const [activeTab, setActiveTab]                          = useState("viewImage");
    const [loading, setLoading]                              = useState(false);
    const [listings, setListings]                            = useState();

    const [uploadStatus, setUploadStatus]                    = useState('');

    const [selectedScript, setSelectedScript]                = useState(null);
   
    useEffect(() => {
      collectScriptsList()
    },[idImage]);

    useEffect(() => {      
      if(activeTab === "addImage" || activeTab === "addMissing"){
        collectScriptInfo()
      }

    },[activeTab]);

    const handleTitleChange = (event) => {
        setTitle(event.target.value);
    };

    const handleNumberChange = (event) => {
        setNumber(event.target.value);
    };

    const handleImageChange = (event) => {
        setImages([...event.target.files]);
    };

    const handleSingleImageChange = (event) => {
      setSingleImage(event.target.files);
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        
        try {

            if(title.length > 0){

              const formData = new FormData();

                formData.append('title', title);
                formData.append('number', number);

                const response = await axios.post(URLstring + "create.php", formData);
                console.log(response.data);
                console.log('Record ID:', response.data.id);
                setIDImage(response.data.id);
                
                setTitle('');

              toast.success('Data submitted successfully!');
            }else{
              toast.warning("Please add script information.")
            }
              
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.error('Submission failed.');
        }
    };

    const handleImageUpload = async () => {

       if(images.length > 0){
           const newProgress = {};
    
        for (const file of images) {
            const formData = new FormData();
            formData.append('image', file);
            formData.append('id', idImage);
            formData.append('issue', number);

            await axios.post(URLstring + 'upload.php', formData, {
                onUploadProgress: (progressEvent) => {
                    const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    newProgress[file.name] = percent;
                    setUploadProgress({ ...newProgress });
                },
            }).then((res) => {
                console.log(res.data);
            }).catch((err) => {
                console.error('Upload error:', err);
            });
        }
       }else {
        toast.warning("Please select images for upload.");
       }       
    };

    const collectScriptsList = async () => {

      try{
        const response = await axios.post(URLstring + "api.php?scriptlist="+ ACCESSCODE);
        console.log(response.data.scripts);
        //
        if(response.data.scripts.length > 0){
          setCurrentScripts(response.data.scripts)
        }else {
          toast.warning("No scripts in list.");
        }
      }catch(err){
        toast.error("Something went wrong fetching data.")
        console.log(err);
      }
    }
    
    const collectScriptInfo = async () => {

      try{

        
        setLoading(true);
        const response = await axios.get(URLstring + "api.php?fullscript="+ ACCESSCODE + "&issue="+selectedScript.number);
        console.log(response.data);
        setListings(response.data.list);
        setLoading(false);

        /*
        if(response.data.scripts.length > 0){
          setCurrentScripts(response.data.scripts)
        }else {
          toast.warning("No scripts in list.");
        }
        */
      }catch(err){
        toast.error("Something went wrong fetching data.");
        setLoading(false);
        console.log(err);
      }
    }

    const handleChangeStatus = async () => {

    }

    const handleSetFeatured = async (featureURL) => {
      try{
        setLoading(true);

        const response = await axios.get(URLstring + "api.php?newUrl="+ featureURL + "&issue="+selectedScript.number);
        
        if(response.data.success){
          toast.success(response.data.message);
        }else {
          toast.warning("Unsuccefull, please try again later.");
        }
        setLoading(false);
      }catch(err){
        console.log(err);
        toast.warning("Something went wrong, please try again later.");
      }
    }

    const handleSingleImageUpload = async (e) => {
      e.preventDefault();

       try{
        
          if(singleImage){
            setLoading(true);
            console.log(selectedScript.id);
            console.log(singleImage[0]);
            console.log(singleImage);
            
            const formData = new FormData();
              formData.append('image', singleImage[0]);
              formData.append('id', selectedScript.id);
              formData.append('issue', selectedScript.number);
              
               const response = await axios.post(URLstring + 'upload.php', formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data',
                  },
                });

                console.log(response);
                if (response.data.success) {
                  toast.success('Image uploaded successfully!');
                } else {
                  toast.error(response.data.message || 'Upload failed');
                }
                 
            setLoading(false);
          }else {
            toast.warning("Please select Image.")
          }

       }catch(err){
        setLoading(false);
        console.log(err);
       }
    }

  return (
    <div className="cont-row row">
       <h1>Image Upload Form</h1>
        <div className="col-md-6">
            <div className="form-lay">
            
              <form onSubmit={handleSubmit}>
                  <div className="form-group">
                      <label htmlFor="title">Title:</label>
                      <input
                          type="text"
                          id="title"
                          value={title}
                          onChange={handleTitleChange}
                          required
                      />
                  </div>
                  <div className="form-group">
                      <label htmlFor="number">Issue:</label>
                      <input
                          type="number"
                          id="number"
                          value={number}
                          onChange={handleNumberChange}
                      />
                  </div>
                  {
                    title.length > 0 && (
                      <button type="submit" className="btn-main mgtop20">
                          Submit
                      </button>
                    )
                  }
                
              </form>

              {idImage !== "" && (
                      <div style={{ marginTop: "20px" }}>
                          <h3>Upload Images for ID {idImage}, issue <strong>#{number}</strong></h3>
                          <input 
                              type="file" 
                              multiple 
                              onChange={handleImageChange}
                              accept="image/*"
                              required
                              />
                          <button
                            className="btn btn-main" 
                            onClick={handleImageUpload}>Upload Images</button>               
                      </div>
                  )
              }

            {uploadStatus && <p>{uploadStatus}</p>}

            {images.length > 0 && (
              <div className="progress-grid">
                {images.map((image, index) => (
                  <div key={index} className="progress-item">
                    <p>{image.name}</p>
                    {uploadProgress[image.name] !== undefined && (
                      <div className="progress-bar-container">
                        <div
                            className="progress-bar"
                            style={{ width: `${uploadProgress[image.name]}%` }}
                          >
                          {uploadProgress[image.name]}%
                        </div>
                      </div>
                    )}
                    {uploadProgress[image.name] === 100 && <p>Uploaded!</p>}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="col-md-3">
          {
            selectedScript && (
              <div className="selected-script">
                <h4>Selected Script</h4>
                <p>{selectedScript.title}</p>
                <button className="btn btn-main"
                  onClick={() => setIsModalOpen(true)}>
                  Edit
                </button>
                <button className="btn btn-main floatr" onClick={() => setSelectedScript(null)}>
                  Cancel
                </button>
              </div>
            )
          }
        </div>
      <div className="col-md-3">
            {
              currentScripts &&
              currentScripts.length > 0 && (
                <ul className="card-listings">
                  {
                    currentScripts.map((current, index) =>
                      {
                        return <li 
                                  key={index} 
                                  className="list-item-card-outer"
                                  onClick={() => setSelectedScript(current)}>
                                  <div className="list-item-card flexme">
                                      <div className="imagery-part">
                                        {
                                          current.featuredImage && (
                                            <img src={current.featuredImage} className="lay-portfolio" />
                                          )
                                        }
                                      </div>
                                      <div className="list-content">
                                          <h4>{current.title} </h4>
                                          <p>{current.number}</p>
                                      </div>
                                  </div>      
                                </li>
                      } )
                  }
                </ul>
              )
            }
      </div>
      {isModalOpen && (
          <div className="modal-overlay">
            <div className="modal-set">
              <div className="body-modal">
                <h4>Edit Script</h4>
                <p>Title: {selectedScript.title}</p>
            
                <p>
                    Link: <a href={'https://scripts.cjdsa.co.za/magazine/' + selectedScript.number} target="_blank"> {'https://scripts.cjdsa.co.za/magazine/' + selectedScript.number}</a>
                </p>
                <div className="body-tabs">
                  <div className="tabs-nav">
                    <button onClick={() => setActiveTab("viewImage")} className={activeTab === "viewImage" ? "active" : ""}>
                      View Image
                    </button>
                    <button onClick={() => setActiveTab("addImage")} className={activeTab === "addImage" ? "active" : ""}>
                      Add Featured Image
                    </button>
                    <button onClick={() => setActiveTab("changeStatus")} className={activeTab === "changeStatus" ? "active" : ""}>
                      Change Status
                    </button>
                    <button onClick={() => setActiveTab("addMissing")} className={activeTab === "addMissing" ? "active" : ""}>
                      Add or Remove  
                    </button>
                  </div>
                </div>

                <div className="tab-content">
                  {activeTab === "viewImage" && (
                    <div>
                      <p>Current Image:</p>
                      {
                        selectedScript?.featuredImage && (
                          <img src={selectedScript.featuredImage} alt="Featured" style={{ maxHeight: "200px", objectFit: "cover" }} />
                        )
                      }                    
                    </div>
                  )}

                  {activeTab === "addImage" && (
                    <div>
                      <p>Select Image for featured:</p>
                       {
                          loading && (<img src="https://cjmarketing.co/image_directory/loading.gif" className="spinner-small"/>)
                       }

                       {
                        listings && 
                        listings.length > 0 && (
                          <div className="height-images-v1 full-images-view">
                            <div className="row">
                               {
                                  listings.map((list, index) => {
                                    return <div className="col-md-2" key={index}>
                                              <div className="imge-part-out" onClick={() => handleSetFeatured(list)}>
                                                  <img src={list} className="imge-view1" />
                                              </div>
                                            </div>
                                  })
                                }
                            </div>
                          </div>
                        )
                      }
                    </div>
                  )}

                  {activeTab === "changeStatus" && (
                    <div>
                      <p>Change Script Status:</p>
                      <select 
                        className="form-control" 
                        onChange={(e) => handleChangeStatus(e.target.value)} value={selectedScript.status}>
                        <option value="draft">Draft</option>
                        <option value="published">Published</option>
                      </select>
                    </div>
                  )}

                  {activeTab === "addMissing" && (
                    <div>
                      <p>Add/Delete Images:</p>
                      {
                        loading && (<img src="https://cjmarketing.co/image_directory/loading.gif" className="spinner-small"/>)
                      }
                      
                      {
                        listings && 
                        listings.length > 0 && (
                          <div className="height-images-v2 rows-full">
                            <form className="sub-part" onSubmit={handleSingleImageUpload}>
                                    <input 
                                      type="file"   
                                      onChange={handleSingleImageChange}
                                      accept="image/*"
                                      required
                                    />
                                <button
                                  className="btn btn-main" 
                                  >Upload Image
                                </button>   
                            </form>
                            <ul className="card-striping">
                               {
                                  listings.map((list, index) => {
                                    return <div className="list-item-card-outer pd10 border-bot mgbot10" key={index}>
                                              <div className="list-item-card flexme" >
                                                 
                                                  <div className="img-view-out">
                                                     <img src={list} className="imge-view1" />
                                                  </div>
                                                  <div className="edit-view-out pd10">
                                                    <div className="text-button">X Delete</div>
                                                    {index + 1}
                                                  </div>
                                              </div>                                              
                                          </div>
                                  })
                                }
                            </ul>
                          </div>
                        )
                      }


                    </div>
                  )}
                </div>

              </div>
              <div className="foot-work">
                <button 
                  className="btn btn-main" 
                  onClick={() => setIsModalOpen(false)}>
                    Close
                  </button>
              </div>
            </div>
          </div>
        )}
    </div>
  )
}

export default Form